// The collapsed sidebar (Console D's rail): chosen with the bar's button or `[`, remembered on
// this device. main.tsx applies it before the first paint (the CSP allows no inline script).
const KEY = 'apsio.nav'

export function readRail(): boolean {
  try {
    return localStorage.getItem(KEY) === 'collapsed'
  } catch {
    return false
  }
}

export function applyRail(collapsed: boolean): void {
  document.documentElement.classList.toggle('nav-c', collapsed)
}

export function saveRail(collapsed: boolean): void {
  applyRail(collapsed)
  try {
    if (collapsed) localStorage.setItem(KEY, 'collapsed')
    else localStorage.removeItem(KEY)
  } catch {
    // Storage blocked: the choice lasts for this page only.
  }
}
